export default __webpack_public_path__ + "static/media/34.3d31ca46.jpg";